import { types } from 'actions/polls/types';

const initialState = {
    isVerifyTokenForPollSuccess: false,
    isVerifyTokenForPollRequest: false,
    isVerifyTokenForPollFailure: false,
    isSendPollSuccess: false,
    isSendPollRequest: false,
    isSendPollFailure: false,
    isUnsubscribeDailyPollSuccess: false,
    isUnsubscribeDailyPollRequest: false,
    isUnsubscribeDailyPollFailure: false,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case types.VERIFY_TOKEN_FOR_POLL_REQUEST:
            return {
                ...state,
                isVerifyTokenForPollRequest: payload,
            };
        case types.VERIFY_TOKEN_FOR_POLL_SUCCESS:
            return {
                ...state,
                isVerifyTokenForPollSuccess: payload,
            };
        case types.VERIFY_TOKEN_FOR_POLL_FAILURE:
            return {
                ...state,
                isVerifyTokenForPollFailure: payload,
            };
        case types.POLL_WAS_SEND_REQUEST:
            return {
                ...state,
                isSendPollRequest: payload,
            };
        case types.POLL_WAS_SEND_SUCCESS:
            return {
                ...state,
                isSendPollSuccess: payload,
            };
        case types.POLL_WAS_SEND_FAILURE:
            return {
                ...state,
                isSendPollFailure: payload,
            };
        case types.UNSUBSCRIBE_DAILY_POLL_REQUEST:
            return {
                ...state,
                isUnsubscribeDailyPollRequest: payload,
            };
        case types.UNSUBSCRIBE_DAILY_POLL_SUCCESS:
            return {
                ...state,
                isUnsubscribeDailyPollSuccess: payload,
            };
        case types.UNSUBSCRIBE_DAILY_POLL_FAILURE:
            return {
                ...state,
                isUnsubscribeDailyPollFailure: payload,
            };
        default:
            return state;
    }
};
